import { ThemeIcon } from "@mantine/core";
import type { ReactNode } from "react";

const style = {
  borderRadius: "6px",
  border: "var(--mapka-border-base) light-dark(black, white)",
};

interface ProductIconProps {
  children: ReactNode;
  iconColor?: string;
  size?: number;
}

export const ProductIcon = ({ children, iconColor, size = 32 }: ProductIconProps) => {
  return (
    <ThemeIcon
      variant="filled"
      size={size}
      c="black"
      style={style}
      color={iconColor}
    >
      {children}
    </ThemeIcon>
  );
};
